import React from 'react';
import {
	getNav4SidebarId,
	useGetParamsForGetNav4SidebarId,
} from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebar-selector/src/common/logic.tsx';
import { GSNForContentSidebar } from './GSNForContentSidebar.tsx';
import { GSNForOtherSidebars } from './GSNForOtherSidebars.tsx';

export function NavPlatformSidebar(): React.JSX.Element {
	/*
		1. Add UFOSegment
		2. Determine which sidebar to show
		  a. If NOT content sidebar,
		    1. render other sidebars within `postMainElement`
			2. disable customisation
			3. Return GSN component
		  b. Otherwise,
		    1. Get items-config (default config), using custom components


	*/
	/*
		Use same sidebar-selector logic as in navigation-apps/sidebar-nav4/sidebar-selector/src/ui/entrypoint/index.tsx
	*/
	const paramsForGetNav4SidebarId = useGetParamsForGetNav4SidebarId();
	const currentSidebarId = getNav4SidebarId(paramsForGetNav4SidebarId);

	if (currentSidebarId === 'CONTENT') {
		return <GSNForContentSidebar />;
	}
	return <GSNForOtherSidebars sidebarId={currentSidebarId} />;
}
